import { connect } from "react-redux";
import RcTransferView from "./RcTransferView";
import { bindActionCreators } from "redux";
import { getAllRcTransfer, updateStatusRcTransfer } from 'services/redux/RcTransfer/action';
import { documentUploadUrlPublic } from "services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
    rcTransferListing: state.rcTransferReducer.rcTransferListing,
    updateRcStatus: state.rcTransferReducer.updateRcStatus,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        getAllRcTransfer,
        updateStatusRcTransfer,
        documentUploadUrlPublic
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RcTransferView);
